import { usePremiumContext } from '../contexts/PremiumContext';

export const usePremium = () => {
  return usePremiumContext();
};
